__turbopack_context__.v({
  "section": "DNgNiG_section",
});
